<template>
  <div class="inputs" ref="inputs">
    <eco-input
      :width="width"
      style="width:100%;"
      size="small"
      :maxlength="maxlength"
      :validate="inputValidate"
      :name="inputName"
      :placeholder="placeholder ? placeholder : '请输入内容'"
      v-model="inputVal"
      :ref="this.atter"
      type="textarea"
      :disabled="isEdit"
      v-if="!isEditor && type != 'property-text'"
      :permission="permission"
    ></eco-input>
    <span
      v-if="type == 'property-text' && !isEditor"
      :style="{ color: valueColor ? valueColor : '#606266' }"
      >{{ inputVal }}</span
    >
    <vue-ueditor-wrap
      v-model="inputVal"
      :config="config"
      v-if="isEditor"
    ></vue-ueditor-wrap>
    <!--用来控制富文本校验-->
    <eco-input
      size="small"
      :validate="inputValidate"
      :permission="permission"
      v-if="isEditor"
      :name="inputName"
      v-model="inputVal"
      :ref="this.atter"
      v-show="false"
      type="input"
    ></eco-input>
  </div>
</template>
<script>
import utils from "@/utils.js";

export default {
  name: "eip-textarea",
  props: [
    "validate",
    "value",
    "name",
    "permission",
    "atter",
    "type",
    "initialFrameHeight",
    "initialFrameWidth",
    "placeholder",
    "isEditor",
    "isInputEdit",
    "textValue",
    "precision",
    "valueColor"
  ],
  data() {
    return {
      maxlength: null,
      width: "100%",
      unwatchAry: [],
      config: {
        initialFrameHeight: 240,
        UEDITOR_HOME_URL: "/ueditor/",
        // UEDITOR_HOME_URL: window.location.origin +'/'+ window.location.pathname.split('/')[1]+'/ueditor/',
        toolbars: [
          [
            "undo", //撤销
            "bold", //加粗
            "indent", //首行缩进
            "italic", //斜体
            "underline", //下划线
            "strikethrough", //删除线
            "subscript", //下标
            "fontborder", //字符边框
            "superscript", //上标
            "formatmatch", //格式刷
            "fontfamily", //字体
            "fontsize", //字号
            "justifyleft", //居左对齐
            "justifycenter", //居中对齐
            "justifyright", //居右对齐
            "justifyjustify", //两端对齐
            "insertorderedlist", //有序列表
            "insertunorderedlist", //无序列表
            "lineheight", //行间距
            "forecolor" //字体颜色
          ]
        ],
        // 初始容器宽度
        initialFrameWidth: "100%",
        zIndex: 100,
        enableAutoSave: false,
        readonly: false
      },
      isEdit: false,
      newValidate: null,
      data: {}
    };
  },
  computed: {
    inputVal: {
      get() {
        let _this = this;
        _this.data = _this.$parent.$vnode.context.$vnode.context.data;
        if (!this.value && this.value != 0) {
          let text = this.textValue;
          let moment = require("moment");
          if (this.textValue) {
            setTimeout(() => {
              let isJoin = false;
              if (text.indexOf("{发起时间:startDate}") != -1) {
                text = text.replace(
                  /\{发起时间:startDate}/g,
                  "发起时间:" + moment().format("YYYY-MM-DD") + " "
                );
                isJoin = true;
              }
              if (text.indexOf("{发起人:startUser}") != -1) {
                let currentUser = this.$store.state.user.currentUserDetail.user;
                text = text.replace(
                  /\{发起人:startUser}/g,
                  "发起人:" + currentUser.fullname + " "
                );
                isJoin = true;
              }
              if (text.indexOf("{所在部门:userOrg}") != -1) {
                let currentOrg = this.$store.state.user.currentOrgDetail;
                var name = "无";
                if (currentOrg && currentOrg.name) {
                  name = currentOrg.name;
                }
                text = text.replace(
                  /\{所在部门:userOrg}/g,
                  "所在部门:" + name + " "
                );
                isJoin = true;
              }
              if (!isJoin) {
                let start = "";
                let end = "";
                for (let i = 0; i < text.length; i++) {
                  if (text.search("<p>") != -1) {
                    text = text.replace("<p>", "");
                    text = text.replace("</p>", "");
                  } else {
                    break;
                  }
                }
                start = text.substring(0, text.indexOf("{"));
                end = text.substring(text.lastIndexOf("}") + 1, text.length);
                let val = text
                  .substring(text.indexOf("{") + 2, text.indexOf("}"))
                  .split(".");
                val = val.filter(v => {
                  return v != "data";
                });
                for (let i = 0; i < val.length; i++) {
                  if (i == 0) {
                    text = _this.data[val[i]];
                  } else if (Array.isArray(text)) {
                    let attrArr = _this.inputName.split("-");
                    let attr = attrArr[attrArr.length - 1];
                    text = text.forEach(v => {
                      if (v[val[i]] != v[attr]) {
                        v[attr] = start + v[val[i]] + end;
                      }
                    });
                  } else {
                    text = text[val[i]];
                    if (!Array.isArray(text)) {
                      text = start + text + end;
                    }
                  }
                }
              }
              this.$emit("input", text);
              return text;
            }, 900);
          }
        } else {
          return this.value;
        }
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    },
    inputValidate: function() {
      if (this.newValidate) {
        return this.newValidate;
      }
      return this.validate;
    }
  },
  async mounted() {
    if (this.initialFrameHeight) {
      this.config.initialFrameHeight = this.initialFrameHeight;
    }
    if (this.initialFrameWidth) {
      this.config.initialFrameWidth = this.initialFrameWidth;
    }
    if (this.isInputEdit || this.permission == "r") {
      this.config.readonly = true;
      this.isEdit = true;
    }
    if (this.inputValidate) {
      const validInput = this.inputValidate.split("|");
      this.maxlength = null;
      validInput.forEach(e => {
        const a = e.indexOf("max:");
        if (a > -1) {
          this.maxlength = parseFloat(e.replace("max:", ""));
        }
      });
    }
  },
  beforeDestroy() {},
  destroyed() {},
  created() {
    // this.$validator = this.$root.$validator;
    this.$root.$validator.errors.clear();
  }
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
